import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    container: {
        width: 24,
        height: 24,
        background: "rgba(48, 73, 103, 0.8)",
        borderRadius: '50%',
        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
    },
    symb: {
        fontWeight: "bold",
        fontSize: "12px",
        color: "#FFFFFF"
    }
}));

const SymbolIcon = ({ text }) => {
    const { container, symb } = useStyles();

    return (
        <div className={container}>
            <div className={symb}>{text}</div>
        </div>
    );
};

export default SymbolIcon;
